import type { GameCommand } from "../../semantic-command";
import type { GameplayEvaluationReceipt } from "../shared/adapter";
import type { TopDownCollectSpec } from "./spec";

/**
 * Decides which validated semantic commands would fix a failed evaluation.
 * Same decision table as the pre-registry bounded-repair; applying the
 * commands and re-evaluating now happens once, generically, in the
 * top-level `bounded-repair.ts` dispatcher shared by every kind.
 */
export function repairCommandsForTopDownCollect(spec: TopDownCollectSpec, failedReceipt: GameplayEvaluationReceipt): readonly GameCommand[] | null {
  const failed = new Set(failedReceipt.checks.filter((check) => !check.passed).map((check) => check.id));
  const commands: GameCommand[] = [];
  if (failed.has("layout-safe") || failed.has("touch-goal")) {
    commands.push({ type: "set-difficulty", hazards: 0, playerSpeed: Math.max(spec.player.speed, 420) });
  }
  if (failed.has("keyboard-goal")) {
    commands.push({ type: "set-objective", goalCollectibles: Math.min(spec.world.goalCollectibles, 20), timeLimitSeconds: 300 });
    if (!commands.some((command) => command.type === "set-difficulty")) {
      commands.push({ type: "set-difficulty", hazards: spec.world.hazards, playerSpeed: 500 });
    }
  }
  if (failed.has("frame-budget")) {
    commands.push({ type: "set-objective", goalCollectibles: Math.min(spec.world.goalCollectibles, 30), timeLimitSeconds: Math.max(spec.world.timeLimitSeconds, 60) });
    commands.push({ type: "set-difficulty", hazards: Math.min(spec.world.hazards, 20), playerSpeed: spec.player.speed });
  }
  return commands.length ? commands : null;
}
